import React, { useState } from 'react';

import { Col, Row } from 'react-bootstrap';
import { css, StyleSheet } from 'aphrodite';
import Select from 'react-select';

import Container from 'components/shared/Container';
import { SkuMappingWorkflowTypesConfig } from 'lib/enums/SkuMappingWorkflowEnum';
import SkuMappingWorkflowEnrichVendor from 'components/enrich/sku_mapping_workflow/sku_mapping_workflow_enrich_vendor/SkuMappingWorkflowEnrichVendor.jsx';
import SkuMappingWorkflowEnrichBrand from 'components/enrich/sku_mapping_workflow/sku_mapping_workflow_enrich_vendor/SkuMappingWorkflowEnrichBrand.jsx';

const WORKFLOW_TYPES = [
  SkuMappingWorkflowTypesConfig.VENDOR,
  SkuMappingWorkflowTypesConfig.DAILY,
  SkuMappingWorkflowTypesConfig.BRAND,
];

function SkuMappingWorkflowEnrichView() {
  const [workflowType, setWorkflowType] = useState();

  // eslint-disable-next-line react/prop-types
  const RenderJson = ({ data }) => {
    if (!data) {
      return null;
    }
    if (typeof data === 'object' && data !== null) {
      return (
        <ul>
          {Object.entries(data).map(([key, value]) => (
            <li key={key}>
              <strong>{key}:</strong> <RenderJson data={value} />
            </li>
          ))}
        </ul>
      );
    } else {
      return <span>{data.toString()}</span>;
    }
  };

  return (
    <Container className={css(styles.container)}>
      <div className="d-flex justify-content-between">
        <h3 className="font-weight-bold">SKU Mapping Workflow</h3>
      </div>
      <Row className="my-3 ml-1">
        <Col sm={3}>
          <Select
            value={workflowType}
            options={WORKFLOW_TYPES}
            onChange={option => setWorkflowType(option)}
            placeholder="Select Workflow Type"
          />
        </Col>
      </Row>
      {workflowType === SkuMappingWorkflowTypesConfig.VENDOR && <SkuMappingWorkflowEnrichVendor />}
      {workflowType === SkuMappingWorkflowTypesConfig.BRAND && <SkuMappingWorkflowEnrichBrand />}
    </Container>
  );
}

const styles = StyleSheet.create({
  container: {
    minHeight: '150vh',
    overflowX: 'hidden',
  },
});

export default SkuMappingWorkflowEnrichView;
